import { getFileTypeByExt } from '@/utils/file/getFileTypeByExt'

export const getFilePreviewByExt = (ext: string): string => {
  if (ext.startsWith('.')) {
    ext = ext.slice(1)
  }
  switch (ext) {
    case 'contact':
      return 'contact'
    case 'doc':
    case 'docx':
      return 'doc'
    case 'json':
      return 'json'
    case 'mail':
      return 'mail'
    case 'pdf':
      return 'pdf'
    case 'ppt':
      return 'ppt'
    case 'svg':
      return 'svg'
    case 'html':
      return 'html'
    case 'css':
    case 'cal':
    case 'txt':
    case 'vcf':
    case 'vcard':
    case 'wap':
      return 'text'
    case 'xlsx':
    case 'xls':
      return 'xls'
    case 'zip':
    case 'tar':
    case 'bz2':
    case 'gz':
      return 'zip'
    case 'csv':
      return 'csv'
    default: {
      if (!ext.startsWith('.')) {
        ext = `.${ext}`
      }
      const type = getFileTypeByExt(ext)
      switch (type) {
        case 'image':
          return 'png'
        case 'video':
          return 'video'
        case 'audio':
          return 'audio'
        default:
          return 'unknown'
      }
    }
  }
}
